import api from '../services/api';
import Swal from 'sweetalert2';

export default function Login() {
  const container = document.createElement('div');
  container.innerHTML = ``;

  // dispara o Swal automaticamente
  Swal.fire({
    timerProgressBar: false,
    timer: null,
    title: 'Acessar Sistema',
    html: `
      <label for="email" class="swal2-label" style="margin-bottom:5px;">Email</label>
      <input id="email" class="swal2-input" type="email" placeholder="Digite seu email" style="margin:0;" />

      <label for="senha" class="swal2-label" style="margin-top:10px;margin-bottom:5px;">Senha</label>
      <input id="senha" class="swal2-input" type="password" placeholder="Digite sua senha" style="margin:0;" />
    `,
    confirmButtonText: 'Entrar',
    cancelButtonText: 'Cancelar',
    showCancelButton: true,
    focusConfirm: false,
    customClass: {
      actions: 'swal2-actions-custom'
    },
    preConfirm: async () => {
      const email = document.getElementById('email').value;
      const senha = document.getElementById('senha').value;

      try {
        const res = await api.post('/login', { email, senha });
        const { token, usuario } = res.data;

       // console.log("usuario: ", usuario);
        if(usuario.cod_tipo_usuario === 'uuid-tipo-usuario-2')
        {
          Swal.showValidationMessage(
          'Acesso não permitido'
          );
          return;
        }
        localStorage.setItem('token', token);
        localStorage.setItem('usuario', JSON.stringify(usuario));
        
        //console.log('usuario');
        //console.log(usuario);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        window.location.hash = '#/dashboard';
      } catch (error) {
        Swal.showValidationMessage(
          error.response?.data?.message || 'Credenciais inválidas'
        );
      }
    }
  });

  return container;
}
